<script setup lang="ts">
import type { FieldSize } from '@/components/fields/KTextField.vue';
import type {
  FinisherModelLookupItem,
  ProductModelLookupItem,
} from '@/helpers/fetchers';

import ProductModelLookup from '@/components/lookups/ProductModelLookup.vue';
import { fetchGetLookupProductFinisher } from '@/helpers/fetchers';

export interface Props {
  modelValue?: string | null;
  customerCode?: string;
  disabled?: boolean;
  readonly?: boolean;
  label?: string;
  size?: FieldSize;
  rules?: ((v: string | null) => boolean | string)[];
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  customerCode: '',
  disabled: false,
  readonly: false,
  label: 'Finisher',
  size: 'md',
  rules: () => [],
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
  'select-item': [item: FinisherModelLookupItem];
}>();

async function fetchItems(search: string): Promise<ProductModelLookupItem[]> {
  const items = await fetchGetLookupProductFinisher(search, props.customerCode);
  return items.map((item) => ({
    ...item,
    type_code: '',
    weight: 0,
    width: 0,
    height: 0,
    length: 0,
  }));
}

function handleUpdate(value: string): void {
  emit('update:modelValue', value);
}

function handleSelectItem(item: ProductModelLookupItem): void {
  emit('select-item', { name: item.name, model_id: item.model_id });
}
</script>

<template>
  <ProductModelLookup
    :model-value="props.modelValue"
    :disabled="props.disabled"
    :readonly="props.readonly"
    :label="props.label"
    :size="props.size"
    :rules="props.rules"
    :fetch-items="fetchItems"
    class="finisherModelLookup"
    data-testid="finisherModelLookup"
    @update:model-value="handleUpdate"
    @select-item="handleSelectItem"
  />
</template>
